import { useState } from 'react';
import { GoAButton, GoAInput } from '@abgov/react-components';
import MediaComponent from './media-upload';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../state/store';
import useCsrService from '../services/csr-api-redux';
import {
  createUser,
  loginUser,
  refreshJwt,
  sendOtp,
} from '../state/slices/authSlice';

export const PocPlayground = ({}) => {
  const dispatch = useDispatch<AppDispatch>();
  const [username, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const csrService = useCsrService();

  return (
    <main>
      <p>POC Playground</p>
      <h1>Log in</h1>
      <GoAButton
        onClick={() => {
          dispatch(
            createUser({
              csrService,
              smsCreateRequest: { action: 'create', sms_number: '4037010102' },
            }),
          ).then((result) => {
            console.log('User created: ', result);
            setUserName(result.payload.username);
          });
        }}
      >
        Create User
      </GoAButton>
      {username}
      <GoAInput
        name="passoword"
        onChange={(item, value) => {
          setPassword(value);
        }}
      ></GoAInput>
      <GoAButton
        onClick={() => {
          dispatch(
            loginUser({
              csrService,
              otpUser: { username, otp: password },
            }),
          ).then((result) => {
            console.log('User logged in: ', result);
          });
        }}
      >
        {' '}
        Log in User{' '}
      </GoAButton>
      <GoAButton
        onClick={() => {
          dispatch(
            sendOtp({
              csrService,
              otpUser: { username },
            }),
          ).then((result) => {
            console.log('User renewed: ', result);
          });
        }}
      >
        Resend OTP
      </GoAButton>
      <GoAButton
        onClick={() => {
          dispatch(
            refreshJwt({
              csrService,
            }),
          ).then((result) => {
            console.log('User jwt refreshed: ', result);
          });
        }}
      >
        Renew JWT
      </GoAButton>

      <h1>File Upload</h1>
      <MediaComponent />
    </main>
  );
};
